import React from 'react';
import { Input } from 'reactstrap';
import { Query } from 'react-apollo';
import { OBregimeConfigurationQuery } from '../../queries/Queries';

const SSCIdSelector = ({ value, onChange, placeholder, disabled }) => {
  const handleChange = (e) => {
    const selectedValue = e.target.value;
    onChange(selectedValue || null);
  };

  return (
    <Query query={OBregimeConfigurationQuery} fetchPolicy='cache-first'>
      {({ loading, error, data }) => {
        const options = data && data.OB_regimeConfiguration ? data.OB_regimeConfiguration : [];

        if (error) {
          // eslint-disable-next-line no-console
          console.error('Error fetching SSC IDs:', error);
        }

        return (
          <Input type='select' value={value || ''} onChange={handleChange} disabled={disabled || loading}>
            <option value=''>{loading ? 'Loading...' : placeholder || 'Select SSC ID'}</option>
            {options.map((option) => (
              <option key={option.id} value={option.name}>
                {option.name}
              </option>
            ))}
          </Input>
        );
      }}
    </Query>
  );
};

export default SSCIdSelector;
